<template>
    <div>
        <h5>All Available Groups</h5>
        <div class="card">
            <!-- :disabled="!checkUserPermission(UserPermissions.WRITE_USER_GROUP)"  -->
            <Button label="Create New User Group" @click="addGroupDialog = true" />
        </div>
        <Dialog v-model:visible="addGroupDialog" :style="{ width: '85vw' }" header="Add New Group" :modal="true" :dismissableMask="true">
        <add-new-group @group-created="groupCreated"/>
        </Dialog>
        <groups-table :reloadGroupTable="reloadGroupTable" :companyId="company_id.id"></groups-table>
    </div>
</template>

<script setup>
import AddNewGroup from './AddNewGroup.vue';
import GroupsTable from './GroupsTable.vue';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const reloadGroupTable = ref(false);
const addGroupDialog = ref(false);

// const isGodUser = computed(() => {
//     return store.getters['auth/isGodUser'];
// });

const company_id = computed(() => {
    return store.getters['auth/userCompanyId'];
});

const groupCreated = () => {
    // console.log('im called')
    addGroupDialog.value = false
    reloadGroupTable.value = true;
};
</script>
